import { Divider, Typography } from '@mui/material';
import React from 'react';

type SecondaryTitleProps = {
  title: string;
  divider?: boolean;
  uppercase?: boolean;
};

export const SecondaryTitle = (props: SecondaryTitleProps) => {
  const { title, divider = false, uppercase = false } = props;
  return (
    <>
      <Typography
        variant='body2'
        textTransform={uppercase ? 'uppercase' : 'none'}
        color='textSecondary'
        fontWeight={(thm) => thm.typography.fontWeightMedium}
        p={2}
      >
        {title}
      </Typography>
      {divider && <Divider />}
    </>
  );
};
